(function () {
  // Übersetzte Strings kommen aus theme.liquid (window.ksI18n) — Fallback Englisch.
  const i18n = window.ksI18n || {};
  const TITLE = i18n.wishlistTitle || "Saved Pieces";
  const SUBTITLE = i18n.wishlistSubtitle || "The wardrobe you're building.";
  const ADD_TO_BAG = i18n.wishlistAddToBag || "Add to Bag";
  const SEARCH_PLACEHOLDER = i18n.wishlistSearchPlaceholder || "Search saved pieces";

  function applyWishlistKS() {
    const popup = document.querySelector(".sewp-engine-popupin");
    if (!popup) return;

    popup.classList.add("ks-wishlist");

    const title = popup.querySelector(".headerwishlist");
    if (title) title.textContent = TITLE;

    if (title && !popup.querySelector(".ks-wishlist-subtitle")) {
      const subtitle = document.createElement("p");
      subtitle.className = "ks-wishlist-subtitle";
      subtitle.textContent = SUBTITLE;
      title.after(subtitle);
    }

    popup.querySelectorAll("button, input[type='button'], input[type='submit']").forEach((btn) => {
      const text = (btn.textContent || btn.value || "").toLowerCase();

      if (text.includes("add to cart") || text.includes("move to cart")) {
        if (btn.tagName === "INPUT") btn.value = ADD_TO_BAG;
        else btn.textContent = ADD_TO_BAG;
      }
    });

    popup.querySelectorAll("input").forEach((input) => {
      if (input.placeholder && input.placeholder.toLowerCase().includes("search")) {
        input.placeholder = SEARCH_PLACEHOLDER;
      }
    });
  }

  const observer = new MutationObserver(applyWishlistKS);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener("click", function () {
    setTimeout(applyWishlistKS, 200);
  });

  applyWishlistKS();
})();